import React from 'react';

/** Page header with optional title and actions on the right. */
export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="ty-page-header">
      <div>
        <h1 className="ty-page-header__title">{title}</h1>
        {subtitle && <p className="ty-page-header__subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="ty-page-header__actions">{actions}</div>}
    </div>
  );
}
